import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class OperatingProfitComponentService {
  URl = this.ConfigService.getAPIBaseUrl() + 'api/Operating_profitloss'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  Insertoperatingdetails(data:any) { 
    return this.http.post(this.URl + '/Insertpl_operating', data);
  }
  getoperatingpldata(APPeriodId: any) {
    return this.http.get(this.URl + '/pl_operating?APPeriodId=' + APPeriodId)
  }
  getoperatingpldata_LY(APPeriodId: any) {
    return this.http.get(this.URl + '/pl_operating_LY?APPeriodId=' + APPeriodId)
  }
  getoperatingpldataLY(id: any) {
    return this.http.get(this.URl + '/pl_operatingLY?id=' + id)
  }
}
